import { Component, Input } from '@angular/core';
import { FunnelBarVm, PipelineFunnelStage } from '../../../../domain/model/pipeline-health.model';

/** The funnel card: the seven stage rows in wire order plus the aging legend pill. */
@Component({
  selector: 'ifbp-pipeline-funnel-card',
  templateUrl: './pipeline-funnel-card.component.html',
  styleUrls: ['./pipeline-funnel-card.component.scss'],
  standalone: false,
})
export class PipelineFunnelCardComponent {
  @Input() bars: FunnelBarVm[] = [];
  /** Carries the server's aging threshold, so the pill and the chip cannot disagree. */
  @Input() legendLabel: string;

  trackByStage(_index: number, bar: FunnelBarVm): PipelineFunnelStage {
    return bar.stage;
  }
}
